import { ProductionCategory } from '@promtver/contracts';

import { ru } from '../i18n/ru';

/** Название категории производства — из файла перевода (ТЗ §8.1). */
export function categoryLabel(category: ProductionCategory | string | null | undefined): string {
  if (!category) return ru.common.notSpecified;
  const key = category as keyof typeof ru.categories;
  return ru.categories[key] ?? category;
}

export const productionCategories: ProductionCategory[] = [
  ProductionCategory.MachineBuilding,
  ProductionCategory.FolkCrafts,
  ProductionCategory.FoodIndustry,
  ProductionCategory.ItAndInnovation,
  ProductionCategory.Energy,
  ProductionCategory.ChemicalIndustry,
  ProductionCategory.Other,
];
